module.exports = __webpack_public_path__ + "static/netflix-tudum-3-eb0674c78fb707d54767381013f5796a.jpg";